import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
export function TestimonialSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-tactical-950 bg-noise relative" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-81">
          {/* Testimonial 1 */}
          <motion.div variants={cardVariants} className="bg-tactical-900 rounded-xl p-8 border border-tactical-800 relative shadow-2xl group hover:border-cyan-900/50 transition-colors duration-300" data-id="element-82">
            <div className="absolute -top-4 -left-4 bg-tactical-800 p-3 rounded-full border border-tactical-700" data-id="element-83">
              <QuoteIcon className="w-6 h-6 text-cyan-accent/70" data-id="element-84" />
            </div>

            <div className="flex gap-1 mb-6 mt-2" data-id="element-85">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-cyan-accent text-cyan-accent" data-id="element-86" />)}
            </div>

            <p className="text-gray-300 text-lg italic mb-8 leading-relaxed" data-id="element-87">
              "Pensaba que estaba exagerando hasta que leí el protocolo. En una
              semana convertí mi piso de 70m² en una fortaleza de paz mental. Mi
              familia ya no siente miedo al leer las noticias."
            </p>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-t border-tactical-800 pt-6" data-id="element-88">
              <div className="font-heading text-xl font-semibold text-white tracking-wide" data-id="element-89">
                Marc R., Madrid
              </div>
              <div className="flex items-center gap-2 bg-green-950/30 text-green-400 text-sm font-medium px-3 py-1.5 rounded-full border border-green-900/50" data-id="element-90">
                <CheckCircleIcon className="w-4 h-4" data-id="element-91" />
                Autonomía de 14 días completada
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div variants={cardVariants} className="bg-tactical-900 rounded-xl p-8 border border-tactical-800 relative shadow-2xl group hover:border-cyan-900/50 transition-colors duration-300" data-id="element-92">
            <div className="absolute -top-4 -left-4 bg-tactical-800 p-3 rounded-full border border-tactical-700" data-id="element-93">
              <QuoteIcon className="w-6 h-6 text-cyan-accent/70" data-id="element-94" />
            </div>

            <div className="flex gap-1 mb-6 mt-2" data-id="element-95">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-cyan-accent text-cyan-accent" data-id="element-96" />)}
            </div>

            <p className="text-gray-300 text-lg italic mb-8 leading-relaxed" data-id="element-97">
              "Como financiero de carrera, el módulo de Liquidez de Crisis me
              salvó. Protegí mis activos antes de la última devaluación
              bancaria. Este bundle se pagó solo el primer día."
            </p>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-t border-tactical-800 pt-6" data-id="element-98">
              <div className="font-heading text-xl font-semibold text-white tracking-wide" data-id="element-99">
                Andrés L., CDMX
              </div>
              <div className="flex items-center gap-2 bg-green-950/30 text-green-400 text-sm font-medium px-3 py-1.5 rounded-full border border-green-900/50" data-id="element-100">
                <CheckCircleIcon className="w-4 h-4" data-id="element-101" />
                Blindaje patrimonial exitoso
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}